import numeral from 'numeral';

export default function hrMoney (value) {
	let v = 0;
	if (value && value !== null && value !== '') {
		v = Number(value);
	}
	return numeral(v).format('0,0.00 $');
}



// WEBPACK FOOTER //
// ./src/filters/hrMoney.js